const USER_BASE = '/services/user/v1';

export const USER_ISLOGGEDIN_SERVICE = `${USER_BASE}/isloggedin`;
export const USER_LANGUAGE_PREFERENCES = 'profile/v1/aud/sub';
export const USER_SUPERHIGHLIGHT_SERVICE = '/services/user/v1/superhighlight';
export const USER_FAVORITE_ADD_PATH = '/services/user/v1/favoriteadd';
export const USER_FAVORITE_DEL_PATH = '/services/user/v1/favoritedel';
export const USER_AUD_PREFERENCES_PATH = '/services/player/v1/getpreferences';
export const USER_STATUS_CONTROL_PIN_PATH =
  '/services/user/v1/statuscontrolpin';
export const USER_STATUS_CONTROL_PIN_CHANNEL_CHECK_PATH =
  'services/user/v2/controlpin/channels/check';
export const USER_STATUS_CONTROL_PIN_CHECK_PATH =
  'services/user/v2/controlpin/check';
